import JSEncrypt from "jsencrypt";
import store from "@/store";
export function getEncrypt(data) {
  const { state } = store;
  const encrypt = new JSEncrypt();
  // 设置公钥
  encrypt.setPublicKey(state.publicKey);
  return encrypt.encrypt(data);
}
